import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Editor } from 'react-draft-wysiwyg';
import { EditorState, convertFromRaw, convertToRaw } from 'draft-js';
import { Button, message } from 'antd';
import { graphql } from 'react-apollo';

import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';

import { draftToolbarOptions } from '../utils/globals';

import MUTATION from '../graphql/mutations/editCustomerAssociateConcernMutation.graphql';
import STORE_QUERY from '../graphql/queries/getCustomerAssociateConcernsQuery.graphql';

class AssociateConcernCompanyBackgroundForm extends Component {
  state = {
    submittingForm: false,
    editorState: EditorState.createEmpty(),
  };

  componentWillMount() {
    const { cacCompanyBackground } = this.props;
    if (cacCompanyBackground) {
      this.setState({
        editorState: EditorState.createWithContent(convertFromRaw(JSON.parse(cacCompanyBackground))),
      });
    }
  }

  handleSave = () => {
    this.setState({
      submittingForm: true,
    });
    const { customer_id, cac_id } = this.props;
    const { editorState } = this.state;

    const company_background = JSON.stringify(convertToRaw(editorState.getCurrentContent()));

    this.props.mutate({
      variables: {
        id: cac_id,
        company_background,
      },
      update: (cache) => {
        const data = cache.readQuery({
          query: STORE_QUERY,
          variables: { customer_id },
        });
        data.associateConcerns = data.associateConcerns.map((ac) => {
          const entry = ac;
          if (entry.id === parseInt(cac_id, 10)) {
            entry.company_background = company_background;
          }
          return entry;
        });
        cache.writeQuery({ query: STORE_QUERY, variables: { customer_id }, data });
      },
    })
      .then(() => {
        this.setState({
          submittingForm: false,
        });
        message.success('Success!');
      })
      .catch((mutateErr) => {
        console.log(mutateErr);
        this.setState({
          submittingForm: false,
        });
        message.error(mutateErr.message);
      });
  };

  render() {
    return (
      <div>
        <h5>Company Background</h5>
        <Editor
          wrapperClassName="rdw-wrapper"
          editorClassName="rdw-editor"
          toolbarClassName="rdw-toolbar"
          editorState={this.state.editorState}
          onEditorStateChange={(editorState) => { this.setState({ editorState }); }}
          toolbar={draftToolbarOptions}
        />

        <Button type="primary" loading={this.state.submittingForm} onClick={this.handleSave}>Save</Button>
      </div>
    );
  }
}

AssociateConcernCompanyBackgroundForm.propTypes = {
  cacCompanyBackground: PropTypes.string,
  cac_id: PropTypes.string.isRequired,
  customer_id: PropTypes.string.isRequired,
  mutate: PropTypes.func.isRequired,
};

export default graphql(MUTATION)(AssociateConcernCompanyBackgroundForm);



// WEBPACK FOOTER //
// ./src/forms/AssociateConcernCompanyBackgroundForm.jsx